import React, { useCallback, useContext, useState } from "react";
import { UserUIStateContext } from "./userUIStateContext";
import { E2Data } from "../lib/ddd/ddd";
import { OrgIdContext } from "./orgId_context";

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const dataTable = new E2Data("EU_UI_AdminTransfomer");

const UserUIStateContextProvider = ({ children }) => {
    const { mainOrgId } = useContext(OrgIdContext);
    const [clientWizardStep, setClientWizardStep] = useState(null);
    const [integrationWizardStep, setIntegrationWizardStep] = useState(null);
    const [clientWizardFinished, setClientWizardFinished] = useState(false);
    const [integrationWizardFinished, setIntegrationWizardFinished] = useState(false);
    const [integrationJson, setIntegrationJson] = useState(null);
    const [integrationSteps, setIntegrationSteps] = useState(null);
    const [integrationDocs, setIntegrationDocs] = useState(null);
    const [integrationData, setIntegrationData] =  useState();
    const [serverDataLoaded, setServerDataLoaded] = useState(false);
    const [rowId, setRowId] = useState();

    const getAllSettingsObject = () => {
        let ret = {};
        ret.integrationData = integrationData;
        ret.clientWizardStep = clientWizardStep;
        ret.integrationWizardStep = integrationWizardStep;
        ret.clientWizardFinished = clientWizardFinished;
        ret.integrationWizardFinished = integrationWizardFinished;
        ret.integrationJson = integrationJson;
        ret.integrationSteps = integrationSteps;
        ret.integrationDocs = integrationDocs;

        return ret;
    }

    
    const saveValues = useCallback((values) =>{
        saveServerData({...getAllSettingsObject(), ...values});
    },[mainOrgId, getAllSettingsObject]);

    const setIntegrationDataHandler = useCallback((value, quietly) => {
        setIntegrationData(value);
        if(!quietly)
            saveServerData({...getAllSettingsObject(), integrationData : value});
    },[mainOrgId, getAllSettingsObject]);

    const setClientWizardStepHandler = useCallback((value, quietly) => {
        setClientWizardStep(value);
        if(!quietly)
        saveServerData({...getAllSettingsObject(), clientWizardStep : value});
    },[mainOrgId, getAllSettingsObject]);

    const setIntegrationWizardStepHandler = useCallback((value, quietly) => {
        setIntegrationWizardStep(value);
        if(!quietly)
        saveServerData({...getAllSettingsObject(), integrationWizardStep : value});
    },[mainOrgId, getAllSettingsObject]);

    const setClientWizardFinishedHandler = useCallback((value, quietly) => {
        setClientWizardFinished(value);
        if(!quietly)
        saveServerData({...getAllSettingsObject(), clientWizardFinished : value});
    },[mainOrgId, getAllSettingsObject]);

    const setIntegrationWizardFinishedHandler = useCallback((value, quietly) => {
        setIntegrationWizardFinished(value);
        if(!quietly)
        saveServerData({...getAllSettingsObject(), integrationWizardFinished : value});
    },[mainOrgId, getAllSettingsObject]);

    const setIntegrationJsonHandler = useCallback((value, quietly) => {
        setIntegrationJson(value);
        if(!quietly)
        saveServerData({...getAllSettingsObject(), integrationJson : value});
    },[mainOrgId, getAllSettingsObject]);

    const setIntegrationStepsHanlder = useCallback((value, quietly) => {
        setIntegrationSteps(value);
        if(!quietly)
        saveServerData({...getAllSettingsObject(), integrationSteps : value});
    },[mainOrgId, getAllSettingsObject]);

    const setIntegrationDocsHandler = useCallback((value, quietly) => {
        setIntegrationDocs(value);
        if(!quietly)
        saveServerData({...getAllSettingsObject(), integrationDocs : value});
    },[mainOrgId, getAllSettingsObject]);

    const saveServerData = useCallback((data) => {
        dataTable.values = {UI_Variables : JSON.stringify(data)};
        dataTable.filter = `Organization="${mainOrgId}"`
        dataTable.Modify();
    }, [mainOrgId])

    const clearServerData = () =>{
        setIntegrationData(null);
        setClientWizardStep(null);
        setIntegrationWizardStep(null);
        setClientWizardFinished(false);
        setIntegrationWizardFinished(false);
        setIntegrationJson(null);
        setIntegrationSteps(null);
        setIntegrationDocs(null);
        setServerDataLoaded(true);
    }

    const loadServerData = (data, rowId) => {
        if(rowId)
            setRowId(rowId);
        if(!data)
            return;

        if(data.hasOwnProperty("integrationData"))
            setIntegrationData(data.integrationData);
        if(data.hasOwnProperty("clientWizardStep"))
            setClientWizardStep(data.clientWizardStep)
        if(data.hasOwnProperty("integrationWizardStep"))
            setIntegrationWizardStep(data.integrationWizardStep)
        if(data.hasOwnProperty("clientWizardFinished"))
            setClientWizardFinished(data.clientWizardFinished)
        if(data.hasOwnProperty("integrationWizardFinished"))
            setIntegrationWizardFinished(data.integrationWizardFinished)
        if(data.hasOwnProperty("integrationJson"))
            setIntegrationJson(data.integrationJson)
        if(data.hasOwnProperty("integrationSteps"))
            setIntegrationSteps(data.integrationSteps)
        if(data.hasOwnProperty("integrationDocs"))
            setIntegrationDocs(data.integrationDocs)
        setServerDataLoaded(true);
    }

    

    const contextValue = {
        clientWizardStep,
        setClientWizardStepHandler,
        loadServerData,
        getAllSettingsObject,
        integrationWizardStep,
        setIntegrationWizardStepHandler,
        clientWizardFinished,
        setClientWizardFinishedHandler,
        integrationWizardFinished,
        setIntegrationWizardFinishedHandler,
        integrationJson,
        setIntegrationJsonHandler,
        integrationSteps,
        setIntegrationStepsHanlder,
        integrationDocs,
        setIntegrationDocsHandler,
        saveValues,
        integrationData,
        setIntegrationDataHandler,
        rowId,
        serverDataLoaded,
        clearServerData,
    };

    return (
        <UserUIStateContext.Provider value={contextValue}>{children}</UserUIStateContext.Provider>
    );
};

export default UserUIStateContextProvider;